const unHandleError = {
  success: false,
  showNotification: true,
  type: 'error',
  message: 'Opps Something Went Wrong',
};

export { unHandleError };
